import React from 'react';
import {
  Box,
  Container,
  Grid,
  Typography,
} from '@mui/material';
import QuickStats from './QuickStats';
import QuickAccess from './QuickAccess';

const DashboardOverview = () => {
  return (
    <Container maxWidth="lg">
      <Box sx={{ mt: 4, mb: 6 }}>
        <Typography variant="h4" gutterBottom>
          Dashboard
        </Typography>

        <Grid container spacing={3}>
          {/* Quick Stats Section */}
          <Grid item xs={12}>
            <QuickStats />
          </Grid>

          {/* Quick Access */}
          <Grid item xs={12}>
            <QuickAccess />
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default DashboardOverview; 